var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.613,
    height: 69.447,
    viewBox: "0 0 48.613 69.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.083,
    x2: 0,
    y2: 0.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 69.447,
    height: 48.613,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(48.613) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M24.306,17.362a3.474,3.474,0,0,0-3.472,3.472v6.945a3.472,3.472,0,1,0,6.945,0V20.834a3.474,3.474,0,0,0-3.472-3.472m41.668,3.472a3.474,3.474,0,0,0,3.472-3.472V3.472A3.474,3.474,0,0,0,65.974,0H3.472A3.474,3.474,0,0,0,0,3.472V17.362a3.474,3.474,0,0,0,3.472,3.472,3.472,3.472,0,1,1,0,6.945A3.474,3.474,0,0,0,0,31.251V45.14a3.474,3.474,0,0,0,3.472,3.472h62.5a3.474,3.474,0,0,0,3.472-3.472V31.251a3.474,3.474,0,0,0-3.472-3.472,3.472,3.472,0,1,1,0-6.945M62.5,14.524a10.409,10.409,0,0,0,0,19.565v7.579H27.779a3.472,3.472,0,1,0-6.945,0H6.945V34.089a10.409,10.409,0,0,0,0-19.565V6.945H20.834a3.472,3.472,0,1,0,6.945,0H62.5Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIcon);
export default __webpack_public_path__ + "static/media/management_icon.3a8a300d4dd6bb5c1cae72a3186ca624.svg";
export { ForwardRef as ReactComponent };